import { useAuth0 } from '@auth0/auth0-react'
import { Button, Grid } from '@mui/material'

export const Login = () => {
  const { loginWithRedirect } = useAuth0()

  return (
    <Grid container justifyContent="center" marginTop="20px">
      <Button
        data-testid="login-button"
        onClick={() => {
          loginWithRedirect()
        }}
      >
        Login
      </Button>
    </Grid>
  )
}
